module.exports = __webpack_public_path__ + "img/photo3_3.713d48f1.jpg";